import { Box } from '@mui/material'
import { useEffect, useState } from 'react'

export function CardImage({
  url,
  quantity,
}: {
  url: string
  quantity: number
}) {
  const [loaded, setLoaded] = useState(false)
  useEffect(() => {
    setLoaded(false)
  }, [url])

  return (
    <Box>
      <Box
        sx={{
          display: loaded ? 'block' : 'none',
          aspectRatio: '12/17',
          position: 'relative',
          width: '100%',
        }}
      >
        <img
          src={url.replace('&version=border_crop', '')}
          alt="Card Preview"
          onLoad={() => setLoaded(true)}
        />
        <Box
          sx={{
            position: 'absolute',
            bottom: 18,
            left: 10,
            backgroundColor: 'primary.main',
            color: 'white',
            px: '8px',
            py: '2px',
            borderRadius: '6px',
          }}
        >
          {quantity}
        </Box>
      </Box>
      <Box
        sx={{
          display: loaded ? 'none' : 'block',
          aspectRatio: '12/17',
          width: '100%',
        }}
      >
        <img
          src="https://hcpttxeoqbewblbbpllw.supabase.co/storage/v1/object/public/mtg/cardback.webp"
          alt="Card Back"
        />
      </Box>
    </Box>
  )
}
